import { separateEntity } from 'config';

export default function (primaryCardData) {
  const { notifyInd, cardInactiveTs } = primaryCardData;
  if (notifyInd === 'SE_MATCH') {
    return separateEntity[notifyInd]();
  }
  if (notifyInd === 'SE_MISMATCH') {
    if (new Date() <= new Date(cardInactiveTs)) {
      return separateEntity[notifyInd](true);
    }
    return separateEntity[notifyInd](false);
  }
  if (notifyInd === 'SE_MISMATCH_MPAY') {
    if (new Date() <= new Date(cardInactiveTs)) {
      return separateEntity[notifyInd](true);
    }
    return separateEntity[notifyInd](false);
  }
  return '';
}
